/* Copyright (C) mroads, LLC - All Rights Reserved
* Unauthorized copying of this file, via any medium is strictly prohibited
* Proprietary and confidential
* Written by Snigdha Dhanireddy <snigdha.dhanireddy@mroads.com>, May 2023
* @flow
*/

import React from 'react';
import { TmsComponents as TmsEnums } from '../../../../enums';
import styles from './Desktop.module.css';
import { Popup, PopupContent } from '../../../../components/Popup';
import Body from '../../components/Body';
import Dialog from '../../../../components/Dialog';
import Container from '../../../../components/Container';
import About from '../../../../components/About';
import HelpPopup from '../../components/HelpPopup';
import CheckLookup from '../../components/CheckLookup';
import Sms from '../../../../components/Sms';
import SmsSuccess from '../../components/SmsSuccess';

export default function Desktop(props) {
    const {
        popup,
        onClosePopup,
        selectedItem,
        onHandleSend,
        isCustomSmsType,
        customSmsList,
        onChangeSmsType,
    } = props;

    const getPopupContent = () => {
        if (!popup) return;
        if (popup && popup?.type === 'spinner') {
            return <Dialog {...popup} />;
        } else if (popup && popup?.type === TmsEnums.tmsAbout) {
            return <About open={true} onClose={onClosePopup} />;
        } else if (popup && popup?.type === TmsEnums.helpPopup) {
            return <HelpPopup open={true} onClose={onClosePopup} />;
        } else if (popup && popup?.type === TmsEnums.tmsCheckSelectionPopup) {
            return <CheckLookup open={true} onClose={onClosePopup} data={popup?.metaData || {}} />;
        } else if (popup && popup?.type === TmsEnums.tmsSms) {
            return (
                <Sms
                    open={true}
                    onClose={onClosePopup}
                    selectedItem={selectedItem}
                    onHandleSend={onHandleSend}
                    isCustomSmsType={isCustomSmsType}
                    customSmsList={customSmsList}
                    onChangeSmsType={onChangeSmsType}
                />
            );
        } else if (popup && popup?.type === TmsEnums.tmsSmsSuccess) {
            return (
                <SmsSuccess
                    open={true}
                    onClose={onClosePopup}
                    success={popup?.metaData?.success}
                    retry={popup?.metaData?.retry}
                />
            );
        } else if (popup && popup.type === 'popup') {
            return (
                <Popup visible={!!popup} popupStyle={{ width: '30vw' }}>
                    <PopupContent {...popup} />
                </Popup>
            );
        }
        return null;
    };

    return (
        <Container style={styles.container}>
            <Body {...props} />
            {getPopupContent()}
        </Container>
    );
}
